import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export interface VideoTutorialDialogData {
  videoUrl: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-sizing-video-tutorial-dialog',
  templateUrl: './sizing-video-tutorial-dialog.component.html',
  styleUrl: './sizing-video-tutorial-dialog.component.scss',
  standalone: false
})
export class SizingVideoTutorialDialogComponent {

  safeVideoUrl: SafeResourceUrl;

  constructor(
    public dialogRef: MatDialogRef<SizingVideoTutorialDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VideoTutorialDialogData,
    sanitizer: DomSanitizer
  ) {
    this.safeVideoUrl = sanitizer.bypassSecurityTrustResourceUrl(data.videoUrl);
  }

  proceed(): void {
    this.dialogRef.close();
  }
}
